import Vue          from "vue";
import App          from "./App.vue";
import router       from "./router";
import store        from "./store";

import vuetify      from "./plugins/vuetify";
import Lightbox     from "./plugins/lightbox";


import "leaflet/dist/leaflet.css";
import "viewerjs/dist/viewer.css";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import "materialize-css/dist/css/materialize.css";
import "pannellum/build/pannellum.css";
import "./scss/vendors/_Dropzone.scss";
import "./scss/project/_helpers.scss";
import "./scss/project.scss";

Vue.config.productionTip = false;

Vue.mixin({
    methods: {
        formatBytes (bytes, decimals = 0) {
            if (bytes === 0) return '0 B';
            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },
        convertToDMS (src, type) {
            let dir;
            function toDMS(n) {
                n = Math.abs(n);
                let d = Math.floor(n);
                n = n - d;
                n *= 60;
                let m = Math.floor(n);
                n = n - m;
                n *= 60;
                let s = Math.floor(n);
                return d + "°" + m + "'" + s + '"';
            }
            if (type == "lat") dir = src > 0 ? "N" : "S";
            else dir = src > 0 ? "E" : "W";
            return toDMS(src) + dir;
        },
        connvertToHumanDate (timestamp){
            const date = new Date(timestamp * 1000);
            return ("0" + date.getDate()).slice(-2) + "." + ("0" + (date.getMonth() + 1)).slice(-2) + "." + date.getFullYear() + " " + ("0" + date.getHours()).slice(-2) + ":" + ("0" + date.getMinutes()).slice(-2);
        }
    }
})

new Vue({
    router,
    store,
    vuetify,
    Lightbox,
    render: h => h(App)
}).$mount('#app')
